import React from "react"
import { PuffLoader } from "react-spinners"

import { FaBookmark, FaRegBookmark } from "../../../../AppReactIcons"

const getBookmarkIcon = (bookmarkState: boolean | null) => {
  if (bookmarkState === true) return <FaBookmark />
  if (bookmarkState === false) return <FaRegBookmark />
  return <PuffLoader size={16} color={"#003b78"} />
}

export default getBookmarkIcon
